import { IBookingSessionBlockBookingBase } from '../../models/bookings';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface IDeclineSessionBlockBookingsServiceProps {
  blockId: string;
  bookingId: string;
}

export async function declineSessionBlockBookingsService({
  blockId,
  bookingId,
}: IDeclineSessionBlockBookingsServiceProps): Promise<IBookingSessionBlockBookingBase> {
  const { data } = await jhsfBookingsApi.post<IBookingSessionBlockBookingBase>(
    `/activities/session-blocks/${blockId}/bookings/${bookingId}/decline`,
    {},
  );

  return data;
}
